function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRightPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer_2",
    width: 24,
    height: 24,
    "data-name": "Layer 2",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__arrow-forward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_16794",
    d: "M0 0H24V24H0z",
    "data-name": "Rectangle 16794",
    transform: "rotate(-90 12 12)",
    style: {
      opacity: 0,
      fill: "#004ab9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_3878",
    d: "M5 13h11.86l-3.63 4.36a1 1 0 0 0 1.54 1.28l5-6a1.19 1.19 0 0 0 .09-.15c0-.05.05-.08.07-.13a.961.961 0 0 0 0-.72c0-.05-.05-.08-.07-.13a1.19 1.19 0 0 0-.09-.15l-5-6a1 1 0 1 0-1.54 1.28L16.86 11H5a1 1 0 0 0 0 2z",
    "data-name": "Path 3878",
    style: {
      fill: "#004ab9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightPrimary);
export default __webpack_public_path__ + "static/media/icon-arrow-right-primary.2d880f538e1805eaa9dd7a48a29ee59c.svg";
export { ForwardRef as ReactComponent };